import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../../models';
import { AuthenticationService } from '../../services';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})

export class PrivacyComponent implements OnInit {
  user: User;
  isLoggedIn: Observable<boolean>;

  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    this.isLoggedIn = this.authenticationService.isLoggedIn();
  }
}
